<template>
  <div v-if="model && model.length > 0" class="text-slate-500 flex flex-wrap gap-1">

    <span
      v-for="typer in model"
      :key="typer.typer_id"
      class="flex items-center gap-2"
      >
      <UiServerImg
        :src="typer.avatar_url"
        class="!w-5 !h-5 rounded-full"
        :alt="typer.sendername"
        :title="typer.sendername"
        />
      <span
        v-if="model.length == 1"
        class=""
        v-text="typer.sendername"
        />
    </span>

    <span v-if="model.length == 1" v-text="t('supportchat.chatwindow.istyping')" />
    <span v-else v-text="model.length + ' ' + t('supportchat.chatwindow.aretyping')" />
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n()
const model = defineModel<ChatTyping[]>();
</script>
